import { Box, Grid } from "@chakra-ui/react"
import Card, { CardProps } from "./Card"
import { bp } from "@utils/MediaQueries"

export interface ProductGridProps {
  containerRef?: any
  products: CardProps[]
}

const ProductGrid: React.FC<ProductGridProps> = ({
  containerRef,
  products,
}) => {
  return (
    <Box w="100%">
      <Grid
        ref={containerRef}
        w="100%"
        h="100%"
        templateColumns={bp(
          "repeat(2, minmax(0, 1fr))",
          null,
          "repeat(3, minmax(0, 1fr))"
        )}
        templateRows="min-content"
        columnGap={bp("10px", null, "24px")}
        rowGap={bp("24px", null, "80px")}
      >
        {products.map((product: CardProps, idx: number) => (
          <Box key={idx}>
            <Card key={`${idx}-${product.slug}`} {...product} />
          </Box>
        ))}
      </Grid>
    </Box>
  )
}

export default ProductGrid
